var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trawl-step-circle--wrapper"},[_c('a-space',{attrs:{"size":"large"}},_vm._l((_vm.number),function(index){return _c('span',{key:index,class:[
        'trawl-step-circle--item',
        _vm.current == index ? 'trawl-step-circle--item-selected' : null,
      ],on:{"click":function($event){return _vm.clickItem(index)}}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }